const resolveCollectionScopeCompanyId = ({ payload, state, ownerKey = '' } = {}) => {
  const payloadCompanyId = String(payload?.meta?.companyId || payload?.companyId || '').trim();

  if (payloadCompanyId) {
    return payloadCompanyId;
  }

  const activeScopeCompanyId = String(state?.activeCompanyScopeCompanyId || '').trim();

  if (activeScopeCompanyId) {
    return activeScopeCompanyId;
  }

  if (!ownerKey) {
    return null;
  }

  return String(state?.[ownerKey] || '').trim() || null;
};

export default resolveCollectionScopeCompanyId;
